import type { ComponentProps } from "@blocknote/react";
import classNames from "classnames";
import { bgStyles, borderStyles, paddingStyles, squareStyles, textStyles } from "ui";

type Props = ComponentProps["GridSuggestionMenu"]["Item"];
export function Item({ item, onClick, isSelected }: Props) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={classNames(
        borderStyles.none,
        paddingStyles.p0,
        squareStyles.square125,
        textStyles.size087,
        textStyles.center,
        borderStyles.radius025,
        {
          [bgStyles.neutral300]: isSelected,
          [bgStyles.none]: !isSelected,
        },
      )}
    >
      {item.icon}
    </button>
  );
}
